var angular=window.angular,ngModule;
try {ngModule=angular.module(["doxy.templates"])}
catch(e){ngModule=angular.module("doxy.templates",[])}
var v1="<div class=\"modal file-transfer-modal\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\">\n<div class=\"modal-dialog\">\n<div class=\"modal-content\">\n<div class=\"modal-body\" ng-bind=\"content\"></div>\n</div>\n</div>\n</div>\n";
var id1="/app/realtime/components/file-transfer/modals/wrapper.ngtemplate.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;